import { Component, OnInit, Input } from '@angular/core';
import { User } from 'firebase';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-card-contact',
  templateUrl: './card-contact.component.html',
  styleUrls: ['./card-contact.component.css']
})
export class CardContactComponent implements OnInit {
  @Input() uid : string;
  user : User;
  constructor(
    private userService: UserService
  ) { }

  ngOnInit() {
    this.userService.getUserById(this.uid).valueChanges().subscribe((data: User)=>{
      this.user = data;
    });
  }
}
